import { type FC, useEffect } from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";
import type { AudienceModalComposerProps } from "./AudienceModalTypes";

const AudienceModalComposer: FC<AudienceModalComposerProps> = ({
	sections,
}) => {
	const { registerSections } = useAudienceModalContext();

	// Register sections whenever they change
	useEffect(() => {
		if (sections.length > 0) {
			registerSections(sections);
		}
	}, [sections, registerSections]);

	// AudienceModalComposer doesn't render anything visible itself
	// It just registers the provided sections
	return null;
};

AudienceModalComposer.displayName = "AudienceModalComposer";

export default AudienceModalComposer;
